import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService } from './main.service';
import { AlarmTypeService } from '../services/alarm-type.service';
import  *  as $ from 'jquery';

@Injectable()
export class UserService {
  userLoged: any=null;
  urlAvatar: string;
  model: any[];
  monitoring:boolean=false;
  map: google.maps.Map;
  markers:google.maps.Marker[]=[];
  showAlarm:boolean = true;
  position:any;
  deviceSelected:any;
  devices:any[];
  overlays:any[];
  alarmTypes:any[];
  playSound:boolean=false;

  constructor(public http: Http, public mainService: MainService, private alarmTypeService:AlarmTypeService) {
    this.alarmTypeService.findAll().then(data => {
      let response: any = data;
      this.alarmTypes = [...response.alarmTypes];
    }).catch(err =>{
      console.log(err);
    });
  }

  buildMenu(){
    this.model = [];
    this.model.push({label: 'Tiempo Real', icon: 'fa fa-fw fa-globe', routerLink: ['/home']});
    if(this.userLoged.idProfile == 1){
      this.model.push({
        label: 'Configuraciones', icon: 'fa fa-fw fa-cogs',
        items: [
          {label: 'Protocolos', icon: 'fa fa-fw fa-barcode', routerLink: ['/protocol']},
          {label: 'Tipos de Equipo', icon: 'fa fa-fw fa-wrench', routerLink: ['/deviceType']},
          {label: 'Empresas', icon: 'fa fa-fw fa-building', routerLink: ['/company']},
          {label: 'Perfiles', icon: 'fa fa-fw fa-users', routerLink: ['/profile']},
          {label: 'Tipos de Alarma', icon: 'fa fa-fw fa-list-ol', routerLink: ['/alarmType']},
          {label: 'Jerarquía de Usuarios', icon: 'fa fa-fw fa-sitemap', routerLink: ['/hierarchy']},
          {label: 'Tipos de Mantenimiento', icon: 'fa fa-fw fa-list-ol', routerLink: ['/maintenanceType']}
        ]
      });
      this.model.push({
        label: 'Administración', icon: 'fa fa-fw fa-laptop',
        items: [
          {label: 'Usuarios', icon: 'fa fa-fw fa-user', routerLink: ['/user']},
          {label: 'Equipos', icon: 'fa fa-fw fa-car', routerLink: ['/device']},
          {label: 'Usuarios - Equipos', icon: 'fa fa-fw fa-cog', routerLink: ['/userDevice']},
          {label: 'Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofence']},
          {label: 'Alarmas', icon: 'fa fa-fw fa-bell-o', routerLink: ['/alarm']},
          {label: 'Puntos de Interes', icon: 'fa fa-fw fa-map-marker', routerLink: ['/interestPoint']},
          {label: 'Conductores', icon: 'fa fa-fw fa-vcard', routerLink: ['/driver']},
          {label: 'Direcciones', icon: 'fa fa-fw fa-map-signs', routerLink: ['/address']},
          {label: 'Envio de Reportes', icon: 'fa fa-fw fa-envelope', routerLink: ['/schedulingReport']},
          {label: 'Mantenimientos', icon: 'fa fa-fw fa-wrench', routerLink: ['/maintenance']}
        ]
      });
      this.model.push({
        label: 'Reportes', icon: 'fa fa-fw fa-folder-open-o',
        items: [
          {label: 'Bitácora', icon: 'fa fa-fw fa-clipboard', routerLink: ['/binnacle']},
          {label: 'Historial Posiciones', icon: 'fa fa-fw fa-map', routerLink: ['/positionHistory']},
          {label: 'Reporte GPS', icon: 'fa fa-fw fa-file', routerLink: ['/positionReport']},
          {label: 'Reporte de Viajes', icon: 'fa fa-fw fa-exchange', routerLink: ['/travelReport']},
          {label: 'Tiempos Estacionados', icon: 'fa fa-fw fa-stop-circle', routerLink: ['/stoppedTimeReport']},
          {label: 'Distancia Recorrida', icon: 'fa fa-fw fa-location-arrow', routerLink: ['/distanceTraveledReport']},
          {label: 'Consumo Combustible', icon: 'fa fa-fw fa-thermometer-half', routerLink: ['/fuelConsumptionReport']},
          {label: 'Exceso de Velocidad', icon: 'fa fa-fw fa-tachometer', routerLink: ['/excessSpeedReport']},
          {label: 'Reporte de Ocio', icon: 'fa fa-fw fa-hand-paper-o', routerLink: ['/leisureReport']},
          {label: 'Reporte de Estado', icon: 'fa fa-fw fa-check', routerLink: ['/statusReport']},
          {label: 'Reporte de Alarmas', icon: 'fa fa-fw fa-warning', routerLink: ['/alarmReport']},
            {label: 'Reporte de Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofenceReport']},
          {label: 'Reporte de Infracciones', icon: 'fa fa-fw fa-exclamation-circle', routerLink: ['/violationReport']},
          {label: 'Fuera de Horario', icon: 'fa fa-fw fa-clock-o', routerLink: ['/drivingOutsideHoursReport']},
          {label: 'Viajes de Conductor', icon: 'fa fa-fw fa-random', routerLink: ['/travelDriverReport']},
          {label: 'Faltas Conductor', icon: 'fa fa-fw fa-thumbs-down', routerLink: ['/alarmDriverReport']},
          {label: 'Equipos sin Reportarse', icon: 'fa fa-fw fa-list', routerLink: ['/deviceWithoutReporting']},
          {label: 'Comandos', icon: 'fa fa-fw fa-terminal', routerLink: ['/commandReport']},
          {label: 'Resumenes', icon: 'fa fa-fw fa-file-text-o',
          items:[
            {label: 'Infracciones', icon: 'fa fa-fw fa-newspaper-o', routerLink: ['/summaryInfractionReport']},
            {label: 'Distancias Recorridas', icon: 'fa fa-fw fa-map-o', routerLink: ['/summaryDistanceTraveledReport']},
            {label: 'Movimientos diarios', icon: 'fa fa-fw fa-file-text', routerLink: ['/summaryInfranctionsByDayReport']}
          ]}
        ]
      });
    }else if(this.userLoged.idProfile == 2 || this.userLoged.idProfile == 3 || this.userLoged.idProfile == 9 || this.userLoged.idProfile == 4 || this.userLoged.idProfile == 8 || this.userLoged.idProfile == 9){
      if(this.userLoged.idProfile == 3 || this.userLoged.idProfile == 9){
        this.model.push({
          label: 'Administración', icon: 'fa fa-fw fa-laptop',
          items: [
            {label: 'Equipos', icon: 'fa fa-fw fa-car', routerLink: ['/device']},
            {label: 'Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofence']},
            {label: 'Alarmas', icon: 'fa fa-fw fa-bell-o', routerLink: ['/alarm']},
            {label: 'Puntos de Interes', icon: 'fa fa-fw fa-map-marker', routerLink: ['/interestPoint']},
            {label: 'Conductores', icon: 'fa fa-fw fa-vcard', routerLink: ['/driver']},
            {label: 'Envio de Reportes', icon: 'fa fa-fw fa-envelope', routerLink: ['/schedulingReport']},
            {label: 'Mantenimientos', icon: 'fa fa-fw fa-wrench', routerLink: ['/maintenance']}
          ]
        });
      }else if(this.userLoged.idProfile == 2){
        this.model.push({
          label: 'Administración', icon: 'fa fa-fw fa-laptop',
          items: [
            {label: 'Equipos', icon: 'fa fa-fw fa-car', routerLink: ['/device']},
            {label: 'Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofence']},
            {label: 'Alarmas', icon: 'fa fa-fw fa-bell-o', routerLink: ['/alarm']},
            {label: 'Puntos de Interes', icon: 'fa fa-fw fa-map-marker', routerLink: ['/interestPoint']},
            {label: 'Envio de Reportes', icon: 'fa fa-fw fa-envelope', routerLink: ['/schedulingReport']},
            {label: 'Mantenimientos', icon: 'fa fa-fw fa-wrench', routerLink: ['/maintenance']}
          ]
        });
      }else{ //Usuario Basico
        this.model.push({
          label: 'Administración', icon: 'fa fa-fw fa-laptop',
          items: [
            {label: 'Equipos', icon: 'fa fa-fw fa-car', routerLink: ['/device']},
            {label: 'Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofence']},
            {label: 'Alarmas', icon: 'fa fa-fw fa-bell-o', routerLink: ['/alarm']},
            {label: 'Puntos de Interes', icon: 'fa fa-fw fa-map-marker', routerLink: ['/interestPoint']}
          ]
        });
      }

      if(this.userLoged.idProfile == 4 || this.userLoged.idProfile == 8){
        this.model.push({
          label: 'Reportes', icon: 'fa fa-fw fa-folder-open-o',
          items: [
            {label: 'Historial Posiciones', icon: 'fa fa-fw fa-map', routerLink: ['/positionHistory']},
            {label: 'Reporte GPS', icon: 'fa fa-fw fa-file', routerLink: ['/positionReport']},
            {label: 'Tiempos Estacionados', icon: 'fa fa-fw fa-stop-circle', routerLink: ['/stoppedTimeReport']},
            {label: 'Distancia Recorrida', icon: 'fa fa-fw fa-location-arrow', routerLink: ['/distanceTraveledReport']},
            {label: 'Consumo Combustible', icon: 'fa fa-fw fa-thermometer-half', routerLink: ['/fuelConsumptionReport']},
            {label: 'Reporte de Alarmas', icon: 'fa fa-fw fa-warning', routerLink: ['/alarmReport']},
            {label: 'Reporte de Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofenceReport']},
            {label: 'Equipos sin Reportarse', icon: 'fa fa-fw fa-list', routerLink: ['/deviceWithoutReporting']},
            {label: 'Comandos', icon: 'fa fa-fw fa-terminal', routerLink: ['/commandReport']}
          ]
        });
      }else{
        if(this.userLoged.idProfile == 2 || this.userLoged.idProfile == 3 || this.userLoged.idProfile == 9){
            this.model.push({
              label: 'Reportes', icon: 'fa fa-fw fa-folder-open-o',
              items: [
                {label: 'Historial Posiciones', icon: 'fa fa-fw fa-map', routerLink: ['/positionHistory']},
                {label: 'Reporte GPS', icon: 'fa fa-fw fa-file', routerLink: ['/positionReport']},
                {label: 'Reporte de Viajes', icon: 'fa fa-fw fa-exchange', routerLink: ['/travelReport']},
                {label: 'Tiempos Estacionados', icon: 'fa fa-fw fa-stop-circle', routerLink: ['/stoppedTimeReport']},
                {label: 'Distancia Recorrida', icon: 'fa fa-fw fa-location-arrow', routerLink: ['/distanceTraveledReport']},
                {label: 'Consumo Combustible', icon: 'fa fa-fw fa-thermometer-half', routerLink: ['/fuelConsumptionReport']},
                {label: 'Exceso de Velocidad', icon: 'fa fa-fw fa-tachometer', routerLink: ['/excessSpeedReport']},
                {label: 'Reporte de Ocio', icon: 'fa fa-fw fa-hand-paper-o', routerLink: ['/leisureReport']},
                {label: 'Reporte de Estado', icon: 'fa fa-fw fa-check', routerLink: ['/statusReport']},
                {label: 'Reporte de Alarmas', icon: 'fa fa-fw fa-warning', routerLink: ['/alarmReport']},
            {label: 'Reporte de Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofenceReport']},
                {label: 'Reporte de Infracciones', icon: 'fa fa-fw fa-exclamation-circle', routerLink: ['/violationReport']},
                {label: 'Fuera de Horario', icon: 'fa fa-fw fa-clock-o', routerLink: ['/drivingOutsideHoursReport']},
                {label: 'Viajes de Conductor', icon: 'fa fa-fw fa-random', routerLink: ['/travelDriverReport']},
                {label: 'Faltas Conductor', icon: 'fa fa-fw fa-thumbs-down', routerLink: ['/alarmDriverReport']},
                {label: 'Equipos sin Reportarse', icon: 'fa fa-fw fa-list', routerLink: ['/deviceWithoutReporting']},
                {label: 'Comandos', icon: 'fa fa-fw fa-terminal', routerLink: ['/commandReport']},
                {label: 'Resumenes', icon: 'fa fa-fw fa-file-text-o',
                items:[
                  {label: 'Infracciones', icon: 'fa fa-fw fa-newspaper-o', routerLink: ['/summaryInfractionReport']},
                  {label: 'Distancias Recorridas', icon: 'fa fa-fw fa-map-o', routerLink: ['/summaryDistanceTraveledReport']},
                  {label: 'Movimientos diarios', icon: 'fa fa-fw fa-file-text', routerLink: ['/summaryInfranctionsByDayReport']}
                ]}
              ]
            });
        }else{
          this.model.push({
            label: 'Reportes', icon: 'fa fa-fw fa-folder-open-o',
            items: [
              {label: 'Historial Posiciones', icon: 'fa fa-fw fa-map', routerLink: ['/positionHistory']},
              {label: 'Reporte GPS', icon: 'fa fa-fw fa-file', routerLink: ['/positionReport']},
              {label: 'Reporte de Viajes', icon: 'fa fa-fw fa-exchange', routerLink: ['/travelReport']},
              {label: 'Tiempos Estacionados', icon: 'fa fa-fw fa-stop-circle', routerLink: ['/stoppedTimeReport']},
              {label: 'Distancia Recorrida', icon: 'fa fa-fw fa-location-arrow', routerLink: ['/distanceTraveledReport']},
              {label: 'Consumo Combustible', icon: 'fa fa-fw fa-thermometer-half', routerLink: ['/fuelConsumptionReport']},
              {label: 'Exceso de Velocidad', icon: 'fa fa-fw fa-tachometer', routerLink: ['/excessSpeedReport']},
              {label: 'Reporte de Ocio', icon: 'fa fa-fw fa-hand-paper-o', routerLink: ['/leisureReport']},
              {label: 'Reporte de Estado', icon: 'fa fa-fw fa-check', routerLink: ['/statusReport']},
              {label: 'Reporte de Alarmas', icon: 'fa fa-fw fa-warning', routerLink: ['/alarmReport']},
            {label: 'Reporte de Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofenceReport']},
              {label: 'Fuera de Horario', icon: 'fa fa-fw fa-clock-o', routerLink: ['/drivingOutsideHoursReport']},
              {label: 'Equipos sin Reportarse', icon: 'fa fa-fw fa-list', routerLink: ['/deviceWithoutReporting']},
              {label: 'Comandos', icon: 'fa fa-fw fa-terminal', routerLink: ['/commandReport']}
            ]
          });
        }

      }

    }else if(this.userLoged.idProfile == 5 || this.userLoged.idProfile == 6 ){
      this.model.push({
        label: 'Configuraciones', icon: 'fa fa-fw fa-cogs',
        items: [
          {label: 'Empresas', icon: 'fa fa-fw fa-building', routerLink: ['/company']},
        ]
      });
      if(this.userLoged.idProfile == 6 ){
        this.model.push({
          label: 'Administración', icon: 'fa fa-fw fa-laptop',
          items: [
            {label: 'Usuarios', icon: 'fa fa-fw fa-user', routerLink: ['/user']},
            {label: 'Equipos', icon: 'fa fa-fw fa-car', routerLink: ['/device']},
            {label: 'Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofence']},
            {label: 'Alarmas', icon: 'fa fa-fw fa-bell-o', routerLink: ['/alarm']},
            {label: 'Puntos de Interes', icon: 'fa fa-fw fa-map-marker', routerLink: ['/interestPoint']},
            {label: 'Conductores', icon: 'fa fa-fw fa-vcard', routerLink: ['/driver']},
            {label: 'Envio de Reportes', icon: 'fa fa-fw fa-envelope', routerLink: ['/schedulingReport']},
            {label: 'Mantenimientos', icon: 'fa fa-fw fa-wrench', routerLink: ['/maintenance']}
          ]
        });
      }else{
        this.model.push({
          label: 'Administración', icon: 'fa fa-fw fa-laptop',
          items: [
            {label: 'Usuarios', icon: 'fa fa-fw fa-user', routerLink: ['/user']},
            {label: 'Equipos', icon: 'fa fa-fw fa-car', routerLink: ['/device']},
            {label: 'Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofence']},
            {label: 'Alarmas', icon: 'fa fa-fw fa-bell-o', routerLink: ['/alarm']},
            {label: 'Puntos de Interes', icon: 'fa fa-fw fa-map-marker', routerLink: ['/interestPoint']}
          ]
        });
      }

      if(this.userLoged.idProfile == 5){
        this.model.push({
          label: 'Reportes', icon: 'fa fa-fw fa-folder-open-o',
          items: [
            {label: 'Historial Posiciones', icon: 'fa fa-fw fa-map', routerLink: ['/positionHistory']},
            {label: 'Reporte GPS', icon: 'fa fa-fw fa-file', routerLink: ['/positionReport']},
            {label: 'Tiempos Estacionados', icon: 'fa fa-fw fa-stop-circle', routerLink: ['/stoppedTimeReport']},
            {label: 'Distancia Recorrida', icon: 'fa fa-fw fa-location-arrow', routerLink: ['/distanceTraveledReport']},
            {label: 'Consumo Combustible', icon: 'fa fa-fw fa-thermometer-half', routerLink: ['/fuelConsumptionReport']},
            {label: 'Reporte de Alarmas', icon: 'fa fa-fw fa-warning', routerLink: ['/alarmReport']},
            {label: 'Reporte de Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofenceReport']},
            {label: 'Equipos sin Reportarse', icon: 'fa fa-fw fa-list', routerLink: ['/deviceWithoutReporting']},
            {label: 'Comandos', icon: 'fa fa-fw fa-terminal', routerLink: ['/commandReport']}
          ]
        });
      }else{
        this.model.push({
          label: 'Reportes', icon: 'fa fa-fw fa-folder-open-o',
          items: [
            {label: 'Historial Posiciones', icon: 'fa fa-fw fa-map', routerLink: ['/positionHistory']},
            {label: 'Reporte GPS', icon: 'fa fa-fw fa-file', routerLink: ['/positionReport']},
            {label: 'Reporte de Viajes', icon: 'fa fa-fw fa-exchange', routerLink: ['/travelReport']},
            {label: 'Tiempos Estacionados', icon: 'fa fa-fw fa-stop-circle', routerLink: ['/stoppedTimeReport']},
            {label: 'Distancia Recorrida', icon: 'fa fa-fw fa-location-arrow', routerLink: ['/distanceTraveledReport']},
            {label: 'Consumo Combustible', icon: 'fa fa-fw fa-thermometer-half', routerLink: ['/fuelConsumptionReport']},
            {label: 'Exceso de Velocidad', icon: 'fa fa-fw fa-tachometer', routerLink: ['/excessSpeedReport']},
            {label: 'Reporte de Ocio', icon: 'fa fa-fw fa-hand-paper-o', routerLink: ['/leisureReport']},
            {label: 'Reporte de Estado', icon: 'fa fa-fw fa-check', routerLink: ['/statusReport']},
            {label: 'Reporte de Alarmas', icon: 'fa fa-fw fa-warning', routerLink: ['/alarmReport']},
            {label: 'Entradas/Salidas Geocerca', icon: 'fa fa-fw fa-map-o', routerLink: ['/geofenceReport']},
            {label: 'Reporte de Infracciones', icon: 'fa fa-fw fa-exclamation-circle', routerLink: ['/violationReport']},
            {label: 'Fuera de Horario', icon: 'fa fa-fw fa-clock-o', routerLink: ['/drivingOutsideHoursReport']},
            {label: 'Viajes de Conductor', icon: 'fa fa-fw fa-random', routerLink: ['/travelDriverReport']},
            {label: 'Faltas Conductor', icon: 'fa fa-fw fa-thumbs-down', routerLink: ['/alarmDriverReport']},
            {label: 'Equipos sin Reportarse', icon: 'fa fa-fw fa-list', routerLink: ['/deviceWithoutReporting']},
            {label: 'Comandos', icon: 'fa fa-fw fa-terminal', routerLink: ['/commandReport']}
          ]
        });
      }
    }else if(this.userLoged.idProfile == 7){
      this.model.push({
        label: 'Administración', icon: 'fa fa-fw fa-laptop',
        items: [
          {label: 'Usuarios - Equipos', icon: 'fa fa-fw fa-cog', routerLink: ['/userDevice']},
        ]
      });
      this.model.push({
        label: 'Reportes', icon: 'fa fa-fw fa-folder-open-o',
        items: [
          {label: 'Bitácora', icon: 'fa fa-fw fa-clipboard', routerLink: ['/binnacle']},
          {label: 'Equipos sin Reportarse', icon: 'fa fa-fw fa-list', routerLink: ['/deviceWithoutReporting']},
          {label: 'Comandos', icon: 'fa fa-fw fa-terminal', routerLink: ['/commandReport']}
        ]
      });
    }
  }

  login(user:String, password:String){
    let loginRequest = {user:user, password:password,channel:"WEB"}
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"user/login",loginRequest)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  resetPassword(email:String){
    let resetPasswordRequest = {email: email};
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"user/resetPassword",resetPasswordRequest)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  changePassword(idUser:String,oldPassword:String, newPassword:String){
    let changePasswordRequest = {idUser: idUser, oldPassword:oldPassword, newPassword:newPassword}
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"user/changePassword",changePasswordRequest)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  forcePasswordChange(idUser:String, newPassword:String){
    let forcePasswordChangeRequest = {idUser: idUser, newPassword:newPassword}
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"user/forcePasswordChange",forcePasswordChangeRequest)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  findUsersBranch(idUser:string) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"user/findUsersBranch/"+idUser)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"user")
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  findUsersRoot() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"user/findUsersRoot")
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  getUserTree(idUser:string) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"user/getUserTree/"+idUser)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  registerTrial(request:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"user/registerTrial",request)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  create(user:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"user",user)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  edit(user:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"user/"+user.idUser,user)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  remove(id:string){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"user/"+id)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }

  addOverlay(overlay){
    this.overlays.push(overlay);
  }

  getContent(position: any){
    let alarm = position.extended.find(i => i.key == "alarm");

    let content = '<div id="iw-container">' +
    '<div class="iw-title" style="text-align:center;">'+position.nameDevice+'</div>' +
    '<div class="iw-content">' +
    '<div>'+
    '<label style="font-weight: bold;">ID: </label><label>'+position.idDevice+'</label>' +
    '</div>'+
    '<div>'+
    '<label style="font-weight: bold;">Fecha/Hora: </label><label>'+position.deviceTime+'</label>' +
    '</div>';

    if(position.speed!=null){
      content +='<div><label style="font-weight: bold;">Velocidad: </label><label>'+position.speed.toFixed(2)+'</label></div>';
    }

    if(alarm != undefined){
      let alarmType = this.alarmTypes.find(item => item.idAlarmType == alarm.value);
      content += alarm.value != undefined && alarm.value != '' ? '<label style="font-weight: bold; color: red;">Alarma: </label><label style="color: red;">'+alarmType.description+'</label>':'';
    }
    content += '</div></div>';
    return content;
  }

  diferenciaEntreFechasEnMinutos(a:Date, b:Date):number{
    return Math.floor((b.getTime() - a.getTime()) / (1000 * 60));
  }

  getLastConnection(fechaHora: String): number{
    if(fechaHora==null){
      return 0;
    }
    let fechaHoraArray = fechaHora.split(" ");
    let fechaArray = fechaHoraArray[0].split("/");
    let horaArray = fechaHoraArray[1].split(":");

    let fechaHoraUltimaConexion = new Date();
    fechaHoraUltimaConexion.setFullYear(+fechaArray[2],+fechaArray[1]-1,+fechaArray[0]);
    fechaHoraUltimaConexion.setHours(+horaArray[0],+horaArray[1],+horaArray[2]);
    let fechaHoraActual = new Date();
    return this.diferenciaEntreFechasEnMinutos(fechaHoraUltimaConexion,fechaHoraActual);
  }

  updateDeviceData(position: any){
    let newArray = [];

    for(let i in this.overlays) {
      if(this.overlays[i].get("idDevice") == position.idDevice){
        this.overlays[i].setMap(null);
        this.overlays[i]=null;
        continue;
      }else{
        newArray.push(this.overlays[i]);
      }
    }
    this.overlays = [...newArray];

    let device = this.devices.find(i => i.idDevice == position.idDevice);
    if(device){
      let lastConnection = this.getLastConnection(device.deviceTime);
      if( lastConnection >= 2880){
        device.url="assets/layout/images/markers/cars/car"+device.icono+"b.png";
      }else if(lastConnection >= 30){
        device.url="assets/layout/images/markers/cars/car"+device.icono+"r.png";
      }else{
        device.url="assets/layout/images/markers/cars/car"+device.icono+".png";
      }

      device.positions = [position,...device.positions];
      device.positions.pop();

      let ignition = device.positions[0].extended.find(i => i.key == 'ignition');
      if(ignition){
        device.ignition == (ignition.value == 'true');
      }else{
        device.ignition = false;
      }
      this.drawDeviceData(device.positions);
    }
  }

  addMarker(position: any){
    if(position==null){
      return;
    }
    let latLng = new google.maps.LatLng(position.latitude, position.longitude);

    let infoWindow = new google.maps.InfoWindow({content: this.getContent(position),maxWidth: 200});

    let color = "";
    let url="";
    let lastConnection = this.getLastConnection(position.deviceTime);
    if( lastConnection >= 2880){
      url="assets/layout/images/markers/cars/car"+position.iconDevice+"b.png";
      color = "black";
    }else if(lastConnection >= 30){
      url="assets/layout/images/markers/cars/car"+position.iconDevice+"r.png";
      color = "red";
    }else{
      url="assets/layout/images/markers/cars/car"+position.iconDevice+".png";
      color = "blue";
    }

    let label = {text: position.nameDevice,color: color,fontSize: "12px",fontWeight: "bold"};
    let icon = {
      url: url,
      scaledSize: new google.maps.Size(45, 45), // scaled size
      origin: new google.maps.Point(0,0), // origin
      anchor: new google.maps.Point(22.5, 38), // anchor,
      labelOrigin: new google.maps.Point(position.nameDevice.length<8?position.nameDevice.length*4:position.nameDevice.length*2,0)
    };

    let marker = new google.maps.Marker({position: latLng,label:label ,icon:icon,zIndex: 10});
    marker.set("idDevice",position.idDevice);
    marker.addListener('click', () => {
      infoWindow.open(this.map, marker);
    });

    google.maps.event.addListener(this.map, 'click', function(){
      infoWindow.close();
    });

    this.overlays.push(marker);

    this.markers.push(marker);

    google.maps.event.addListener(infoWindow, 'domready', function() {
      var iwOuter = $('.gm-style-iw');
      var iwBackground = iwOuter.prev();
      iwBackground.children(':nth-child(2)').css({'display' : 'none'});
      iwBackground.children(':nth-child(4)').css({'display' : 'none'});
      // Moves the infowindow 115px to the right.
      //iwOuter.parent().parent().css({left: '115px'});
      //iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
      //iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
      //iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

      var iwCloseBtn = iwOuter.next();
      //iwCloseBtn.css({opacity: '1', right: '78px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
      //iwCloseBtn.css({opacity: '1', right: '30px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
      iwCloseBtn.css({'display' : 'none'});

      iwCloseBtn.mouseout(function(){
        $(this).css({opacity: '1'});
      });
    });

    let alarm = position.extended.find(i => i.key == "alarm");
    if(this.showAlarm && alarm != undefined && alarm.value != undefined && alarm.value != ''){
      infoWindow.open(this.map, marker);
      this.showAlarm = false;
      if(this.playSound){
        this.playAudio();
      }
      setTimeout(()=> { // map will need some time to load
        this.map.setCenter(new google.maps.LatLng(position.latitude, position.longitude));
      }, 1000);
      setTimeout(()=> { // map will need some time to load
        infoWindow.close();
      }, 30000);
    }
  }

  updatePosition(position:any){
    if(this.deviceSelected && this.deviceSelected.idDevice == position.idDevice){
      this.position = {...position};
    }
    this.updateDeviceData(position);
  }

  loadOverlays(){
    this.devices.forEach(device => {
      if(device.positions){
        this.drawDeviceData(device.positions);
      }
    });
  }

  getDistanceInMeters(positionIni:any,positionFin:any) : number{
    let R = 6371;
    let dLat = (positionFin.latitude-positionIni.latitude) * (Math.PI/180);
    let dLon = (positionFin.longitude-positionIni.longitude) * (Math.PI/180);
    let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(positionIni.latitude * (Math.PI/180)) * Math.cos(positionFin.latitude * (Math.PI/180)) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    let d = R * c;
    return d*1000;
  }

  drawDeviceData(positions:any[]){
    if(!positions || positions.length == 0){
      return;
    }
    let recorrido = new google.maps.Polyline({
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 3
    });

    let positionOld : any = null;
    positions.forEach(item => {
      let latLng = new google.maps.LatLng(item.latitude, item.longitude);
      recorrido.getPath().push(latLng);
      if(positionOld!=null){
        let distance = this.getDistanceInMeters(item,positionOld)
        if(distance > 200){
          this.addMarkerRecorrido(item);
        }
      }
      positionOld = item;
    });
    recorrido.set("idDevice",positions[0].idDevice);
    this.overlays.push(recorrido);
    this.addMarker(positions[0]);
    //this.polyLines.push(recorrido);
  }

  addMarkerRecorrido(position: any){
    let latLng = new google.maps.LatLng(position.latitude, position.longitude);

    let infoWindow = new google.maps.InfoWindow({content: this.getContent(position)});
    //let label = {text: position.nameDevice,color: 'blue',fontSize: "12px",fontWeight: "bold"};
    var icon = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      scale:1.3,
      fillColor: 'green',
      strokeColor: 'green',
      strokeWeight: 4,
      rotation:position.course,
      anchor: new google.maps.Point(-0.5, 0.5)
    };

    let marker = new google.maps.Marker({position: latLng,icon:icon});
    marker.set("idDevice",position.idDevice);

    google.maps.event.addListener(marker,'click', function() {
      infoWindow.open(this.map, marker);
    });
    google.maps.event.addListener(this.map, 'click', function(){
      infoWindow.close();
    });
    this.overlays.push(marker);

    //this.markersRecorrido.push(marker);

    google.maps.event.addListener(infoWindow, 'domready', function() {
      var iwOuter = $('.gm-style-iw');
      var iwBackground = iwOuter.prev();
      iwBackground.children(':nth-child(2)').css({'display' : 'none'});
      iwBackground.children(':nth-child(4)').css({'display' : 'none'});
      // Moves the infowindow 115px to the right.
      //  iwOuter.parent().parent().css({left: '115px'});
      //  iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
      //    iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
      //  iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

      var iwCloseBtn = iwOuter.next();
      //iwCloseBtn.css({opacity: '1', right: '30px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
      iwCloseBtn.css({'display' : 'none'});
      iwCloseBtn.mouseout(function(){
        $(this).css({opacity: '1'});
      });
    });
  }

  playAudio(){
    let audio = new Audio();
    audio.src = "../../../assets/layout/audio/notify.mpeg";
    audio.load();
    audio.play();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts